import { useGame } from '@/store/game';

/**
 * Вход в паузу. Держится тише всего остального на экране: сюда заходят раз за
 * вечер — свериться с правилами или закончить, — а тянут карточку каждую минуту.
 * Зона тапа при этом полная: мелкой кнопки в темноте не существует.
 */
export function PauseButton() {
  const setPaused = useGame((s) => s.setPaused);

  return (
    <button
      type="button"
      onClick={() => setPaused(true)}
      className="min-h-tap px-2 text-meta uppercase tracking-widest text-mute"
    >
      Пауза
    </button>
  );
}
